import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';

declare global {
  interface Window {
    Upscope: any;
  }
}

@Injectable({ providedIn: 'root' })
export class UpScopeService {
  private readonly UPSCOPE_SCRIPT_ID = 'upscope-script';

  constructor(@Inject(DOCUMENT) private readonly doc: Document) {
  }

  private readonly setupUpscope = (): void => {
    if (typeof window.Upscope !== 'function') {
      const upScopeQueue: any = (...args: any[]) => upScopeQueue.c(args);
      upScopeQueue.q = [];
      upScopeQueue.c = (args: any) => upScopeQueue.q.push(args);
      window.Upscope = upScopeQueue;

      const script = this.doc.createElement('script');
      script.id = this.UPSCOPE_SCRIPT_ID;
      script.type = 'text/javascript';
      script.async = false;
      script.src = (this.doc.location.host === 'www.benefitmanagertoolkit.com')
        ? 'https://code.upscope.io/rMccHqnmWV.js'
        : 'https://code.upscope.io/ZmwxXffb61.js';
      const firstScript = this.doc.getElementsByTagName('script')[0];
      firstScript.parentNode?.insertBefore(script, firstScript);
    }
  }

  upScopeCookie = (): void => {
    // Avoid double loading
    if (this.doc.getElementById(this.UPSCOPE_SCRIPT_ID)) {
      try {
        window.Upscope?.('init');
      } catch (error) {
        console.warn('Upscope reinitialization failed', error);
      }
      return;
    }
    this.setupUpscope();
    try {
      window.Upscope?.('init');
    } catch (e) {
      console.error('Upscope initialization failed', e);
    }
  }
}
